import {
  ChargingStationDetailSlideIn,
  ChargingStationLinksTab,
  ChargingStationLoggingTab,
  ChargingStationOverviewTab,
  ChargingStationsPage
} from '@infuse/e-connector/charging-station/pages';
import { InfusePageView } from '@infuse/ui/layouts';
import { AppRouter } from '@infuse/ui/router';
import { Plugin } from 'vue';
import { centralSystemPermissions } from '@infuse/api/e-connector/central-system';
import { messagePermissions } from '@infuse/api/e-connector/message';
import { chargingStationPermissions } from '@infuse/api/e-connector/charging-station';
import { basicAuthDeviationPermissions } from '@infuse/api/e-connector/basic-auth-deviation';
import { networkProfilePermissions } from '@infuse/api/e-connector/network-profile';

export const ChargingStationFeaturePlugin: Plugin = {
  install() {
    AppRouter.addRoute('main', {
      path: '/charging-stations',
      component: InfusePageView,
      meta: {
        name: 'nav.chargingStations',
        icon: 'charging-stations',
        group: 'nav.nav-group.manage',
        permissionIds: [chargingStationPermissions.SEARCH, basicAuthDeviationPermissions.GET_ALL, networkProfilePermissions.SEARCH],
        permissionCheck: 'all'
      },
      children: [
        {
          path: '',
          name: 'charging-stations',
          component: ChargingStationsPage
        },
        {
          path: ':id',
          components: {
            default: ChargingStationsPage,
            slideIn: ChargingStationDetailSlideIn
          },
          children: [
            {
              path: '',
              redirect: {
                name: 'charging-stations.overview'
              }
            },
            {
              path: 'overview',
              name: 'charging-stations.overview',
              component: ChargingStationOverviewTab,
              meta: {
                type: 'tab',
                label: 'tabs.chargingStations.overview',
                permissionIds: [chargingStationPermissions.GET]
              }
            },
            {
              path: 'logging',
              name: 'charging-stations.logging',
              component: ChargingStationLoggingTab,
              meta: {
                type: 'tab',
                label: 'tabs.chargingStations.logging',
                permissionIds: [messagePermissions.SEARCH, chargingStationPermissions.GET]
              }
            },
            {
              path: 'links',
              name: 'charging-stations.linkedSystems',
              component: ChargingStationLinksTab,
              meta: {
                type: 'tab',
                label: 'tabs.chargingStations.linkedSystems',
                permissionIds: [centralSystemPermissions.SEARCH, chargingStationPermissions.GET]
              }
            }
          ]
        }
      ]
    });
  }
};
